import React from "react";
import MyButton from "../Shared/Button";
import VariantForm from "./VariantForm";
import { v4 as uuidv4 } from "uuid";

interface AddVariantsProps {
  variantFields: any[]; // Replace 'any' with a more specific type if available
  variantInitialValues: Record<string, any>;
  variantForms: Array<Record<string, any> & { formKey: string }>;
  setVariantForms: React.Dispatch<React.SetStateAction<Array<Record<string, any> & { formKey: string }>>>;
  shouldValidate?: boolean;
  variantFormsErrors: Record<string, string>[];
}

const AddVariants: React.FC<AddVariantsProps> = ({
  variantFields,
  variantInitialValues,
  variantForms,
  setVariantForms,
  shouldValidate = false,
  variantFormsErrors,
}) => {
  const addNewVariationForm = () => {
    setVariantForms([...variantForms, { ...variantInitialValues, formKey: uuidv4() }]);
  };

  const handleOnVariantFormUpdate = (index: number, formValues: Record<string, any>) => {
    const updatedForms :any = [...variantForms];
    updatedForms[index] = formValues;
    setVariantForms(updatedForms);
  };

  const handleRemoveForm = (index: number) => {
    const updatedForms = [...variantForms];
    updatedForms.splice(index, 1);
    setVariantForms(updatedForms);
    
    const updatedErrors = [...variantFormsErrors];
    updatedErrors.splice(index, 1);
  };

  const renderForms = () => {
    return variantForms.map((form, i) => {
      return (
        <VariantForm
          key={form.formKey}
          index={i}
          formData={form}
          fields={variantFields}
          onFormUpdate={handleOnVariantFormUpdate}
        //   shouldValidate={shouldValidate}
          formsErrors={variantFormsErrors[i] || {}}
          removeForm={handleRemoveForm}
        />
      );
    });
  };

  return (
    <>
      {renderForms()}
      <MyButton 
        type="button" 
        title="Add Variation" 
        className="text-black" 
        onClick={addNewVariationForm} 
      />
    </>
  );
};

export default AddVariants;